export const currentBannerHeight = { value: 0 };
